import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import Grid from '@mui/material/Grid2';
import { Box, Button, Paper } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';
import { sharedStyles } from '../../../utils/Style';

export const PointSystemSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.POINT_SYSTEM)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(SettingsType.POINT_SYSTEM, key, settings, newValue),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings)
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <Paper
          sx={{
            p: 1.5,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            height: '95%',
          }}
        >
          <Waiting open={loading} />

          <SettingsRow
            name='Kullanım İçin Minimum Sipariş Tutarı'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(settings, 'point_min_value')}
            onChange={(newValue) => handleChange('point_min_value', newValue)}
            minValue={0}
          />
          <SettingsRow
            name='1 TL Puan Karşılığı'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(settings, 'point_value')}
            onChange={(newValue) => handleChange('point_value', newValue)}
            minValue={0}
          />
          <SettingsRow
            name='Yorum Ödülü'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(settings, 'comment_value')}
            onChange={(newValue) => handleChange('comment_value', newValue)}
            minValue={0}
          />
          <SettingsRow
            name='Üyelik Ödülü'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(settings, 'register_value')}
            onChange={(newValue) => handleChange('register_value', newValue)}
            minValue={0}
          />
          <SettingsRow
            name='Alışveriş Ödülü'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(settings, 'shopping_value')}
            onChange={(newValue) => handleChange('shopping_value', newValue)}
            minValue={0}
          />
          <SettingsRow
            name='Minimum Kullanılabilir Puan'
            valueType={SettingsValueType.NUMBER}
            value={getSettingsValue(settings, 'min_point_usage_value')}
            onChange={(newValue) =>
              handleChange('min_point_usage_value', newValue)
            }
            minValue={0}
          />

          <Box sx={{ display: 'flex', flexGrow: 1 }} />
          <Box display='flex' justifyContent='flex-end'>
            <Button
              variant='contained'
              onClick={handleSave}
              sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
            >
              Kaydet
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
